import MenuItemId from "./MenuItemId.ts";
import Contacts from "../../assets/MenuSvgIcons/contact-icon.svg";
import Admin from "../../assets/MenuSvgIcons/admin-icon.svg";
import Feeearner from "../../assets/MenuSvgIcons/feeearner-icon.svg";
import Nominals from "../../assets/MenuSvgIcons/nominal-icon.svg";
import Purchase from "../../assets/MenuSvgIcons/purchase-icon.svg";
import Consultant from "../../assets/MenuSvgIcons/consultant-icon.svg";
import Reports from "../../assets/MenuSvgIcons/report-icon.svg";
import Dashboard from "../../assets/MenuSvgIcons/dashboard-icon.svg";
import Postings from "../../assets/MenuSvgIcons/posting-icon.svg";
import Clients from "../../assets/MenuSvgIcons/client-icon.svg";
import Workdone from "../../assets/MenuSvgIcons/workdone-icon.svg";
import Tasks from "../../assets/MenuSvgIcons/tasks-icon.svg";
import Matters from "../../assets/MenuSvgIcons/Matters.svg";
import { Tabs } from "components/Enums/TabEnums.ts";
import { SideBarDataItem } from "./MenuData.types";
import { AccountsAccessRights, CaseAccessRights, ReportsAccessRights } from "../../components/UserAccessRights.ts";

export const sideBarData: SideBarDataItem[] = [
    {
        id: MenuItemId.Dashboard,
        text: "Dashboard",
        name: "Dashboard",
        icon: Dashboard,
        selected: true,
        route: "/dashboard",
        tabId: Tabs.ACCOUNTS_DASHBOARD,
    },
    {
        id: MenuItemId.Clients,
        text: "Clients",
        name: "Clients",
        icon: Clients,
        route: "/clients",
        tabId: Tabs.CLIENTS,
    },
    {
        id: MenuItemId.Matters,
        text: "Matters",
        name: "Matters",
        icon: Matters,
        route: "/matters",
        tabId: Tabs.MATTERS,
    },
    {
        id: MenuItemId.WorkDone,
        text: "Work Done",
        name: "Work Done",
        icon: Workdone,
        route: "/workdone",
        tabId: Tabs.WORK_DONE,
    },
    {
        id: MenuItemId.Contacts,
        text: "Contacts",
        name: "Contact",
        icon: Contacts,
        route: "/contacts",
        tabId: Tabs.CONTACTS,
    },
    {
        id: MenuItemId.Tasks,
        text: "Tasks",
        name: "Tasks",
        icon: Tasks,
        route: "/tasks",
        tabId: Tabs.TASKS,
    },
    {
        id: MenuItemId.Accounts,
        text: "Postings",
        icon: Postings,
        ["data-expanded"]: false,
        parent: true.toString(),
        route: "/accounts",
        tabId: Tabs.ACCOUNTS,
    },
    {
        id: MenuItemId.BatchPosting,
        parentId: MenuItemId.Accounts,
        text: "Batch Posting",
        name: "Batch Posting",
        icon: "k-i-minus",
        route: "/batchposting",
        flag: "first",
        requiredAccess: AccountsAccessRights.BatchPostings,
    },
    {
        id: MenuItemId.Billing,
        parentId: MenuItemId.Accounts,
        text: "Bills",
        name: "Bills",
        icon: "k-i-minus",
        route: "/billing",
        requiredAccess: AccountsAccessRights.AddBills,
    },
    {
        id: MenuItemId.OfficePostings,
        parentId: MenuItemId.Accounts,
        text: "Office Postings",
        name: "Office Postings",
        icon: "k-i-minus",
        route: "/officepostings",
        requiredAccess: AccountsAccessRights.OfficePostings,
    },
    {
        id: MenuItemId.OfficeCreditAndAlloc,
        parentId: MenuItemId.Accounts,
        text: "Office Allocations",
        name: "Office Allocations",
        icon: "k-i-minus",
        route: "/officeallocations",
        requiredAccess: AccountsAccessRights.OfficeAllocations,
    },
    {
        id: MenuItemId.ClientPostings,
        parentId: MenuItemId.Accounts,
        text: "Client Postings",
        name: "Client Postings",
        icon: "k-i-minus",
        route: "/clientpostings",
        requiredAccess: AccountsAccessRights.ClientPostings,
    },
    {
        id: MenuItemId.Transfers,
        parentId: MenuItemId.Accounts,
        text: "Transfers",
        name: "Transfers",
        icon: "k-i-minus",
        route: "/transfer",
        requiredAccess: AccountsAccessRights.TransferPostings,
    },
    {
        id: MenuItemId.CTOSweep,
        parentId: MenuItemId.Accounts,
        text: "CTO Sweep",
        name: "CTO Sweep",
        icon: "k-i-minus",
        route: "/ctosweep",
        requiredAccess: AccountsAccessRights.TransferPostings,
    },
    {
        id: MenuItemId.InterestCalculator,
        parentId: MenuItemId.Accounts,
        text: "Interest Calculator",
        name: "Interest Calculator",
        icon: "k-i-minus",
        route: "/interestcalculator",
        requiredAccess: AccountsAccessRights.ClientPostings,
    },
    {
        id: MenuItemId.MatterLedger,
        parentId: MenuItemId.Accounts,
        text: "Ledger Card",
        name: "Ledger Card",
        icon: "k-i-minus",
        route: "/matterledger",
        flag: "last",
        requiredAccess: AccountsAccessRights.ViewMatterLedger,
    },
    {
        id: MenuItemId.Nominal,
        text: "Nominal",
        icon: Nominals,
        ["data-expanded"]: false,
        parent: true.toString(),
        route: "/nominal",
        tabId: Tabs.NOMINAL,
    },
    {
        id: MenuItemId.Nominals,
        parentId: MenuItemId.Nominal,
        text: "Nominals",
        name: "Nominal",
        icon: "k-i-minus",
        route: "/nominals",
        flag: "first",
    },
    {
        id: MenuItemId.NominalLedger,
        parentId: MenuItemId.Nominal,
        text: "Nominal Ledger",
        name: "Nominal Ledger",
        icon: "k-i-minus",
        route: "/nominalledger",
        requiredAccess: AccountsAccessRights.NominalLedger,
    },
    {
        id: MenuItemId.BankPostings,
        parentId: MenuItemId.Nominal,
        text: "Bank Postings",
        name: "Bank Postings",
        icon: "k-i-minus",
        route: "/bankpostings",
        requiredAccess: AccountsAccessRights.BankPostings,
    },
    {
        id: MenuItemId.JournalPostings,
        parentId: MenuItemId.Nominal,
        text: "Journal Posting",
        name: "Journal Posting",
        icon: "k-i-minus",
        route: "/journalposting",
        requiredAccess: AccountsAccessRights.JournalPostings,
    },
    {
        id: MenuItemId.VATReturn,
        parentId: MenuItemId.Nominal,
        text: "VAT Return",
        name: "VAT Return",
        icon: "k-i-minus",
        route: "/vatreturn",
        requiredAccess: AccountsAccessRights.VATReturn,
    },
    {
        id: MenuItemId.BankRec,
        parentId: MenuItemId.Nominal,
        text: "Bank Rec",
        name: "Bank Rec",
        icon: "k-i-minus",
        route: "/bankrec",
        requiredAccess: AccountsAccessRights.BankRec,
    },
    {
        id: MenuItemId.TransactionPeriods,
        parentId: MenuItemId.Nominal,
        text: "Transaction Periods",
        name: "Transaction Periods",
        icon: "k-i-minus",
        route: "/transactionperiod",
        requiredAccess: AccountsAccessRights.AccountsAdmin,
    },
    {
        id: MenuItemId.YearEnd,
        parentId: MenuItemId.Nominal,
        text: "Year End",
        name: "Year End",
        icon: "k-i-minus",
        route: "/yearend",
        flag: "last",
        requiredAccess: AccountsAccessRights.AccountsAdmin,
    },
    {
        id: MenuItemId.Purchase,
        text: "Purchase",
        icon: Purchase,
        ["data-expanded"]: false,
        parent: true.toString(),
        route: "/purchase",
        flag: "first",
        tabId: Tabs.PURCHASE,
    },

    {
        id: MenuItemId.Consultant,
        text: "Consultant",
        icon: Consultant,
        ["data-expanded"]: false,
        parent: true.toString(),
        route: "/consultant",
        flag: "first",
        tabId: Tabs.CONSULTANT,
    },

    {
        id: MenuItemId.Consultants,
        parentId: MenuItemId.Consultant,
        text: "Consultants",
        icon: "k-i-minus",
        ["data-expanded"]: false,
        route: "/consultants",
        flag: "first",
    },

    {
        id: MenuItemId.ConsultantLedger,
        parentId: MenuItemId.Consultant,
        text: "Consultant Ledger",
        icon: "k-i-minus",
        ["data-expanded"]: false,
        route: "/consultantledger",
    },

    {
        id: MenuItemId.ConsultantBilling,
        parentId: MenuItemId.Consultant,
        text: "Consultant Billing",
        icon: "k-i-minus",
        ["data-expanded"]: false,
        route: "/consultantbilling",
    },

    {
        id: MenuItemId.PayConsultant,
        parentId: MenuItemId.Consultant,
        text: "Pay Consultant",
        icon: "k-i-minus",
        ["data-expanded"]: false,
        route: "/payconsultant",
    },

    {
        id: MenuItemId.ConsultantPaymentRun,
        parentId: MenuItemId.Consultant,
        text: "Payment Run",
        name: "Payment Run",
        icon: "k-i-minus",
        ["data-expanded"]: false,
        route: "/paymentrun",
        flag: "last",
    },

    {
        id: MenuItemId.Suppliers,
        parentId: MenuItemId.Purchase,
        text: "Suppliers",
        name: "Suppliers",
        icon: "k-i-minus",
        route: "/suppliers",
        flag: "first",
    },
    {
        id: MenuItemId.SupplierLedger,
        parentId: MenuItemId.Purchase,
        text: "Supplier Ledger",
        name: "Supplier Ledger",
        icon: "k-i-minus",
        route: "/supplierledger",
        requiredAccess: AccountsAccessRights.SupplierLedger,
    },
    {
        id: MenuItemId.PurchaseInvoicePostings,
        parentId: MenuItemId.Purchase,
        text: "Purchase Invoice",
        name: "Purchase Invoice",
        icon: "k-i-minus",
        route: "/purchaseinvoice",
        requiredAccess: AccountsAccessRights.PurchaseInvoice,
    },
    {
        id: MenuItemId.DisbursementPostings,
        parentId: MenuItemId.Purchase,
        text: "Disbursements",
        name: "Disbursement",
        icon: "k-i-minus",
        route: "/disbursements",
        requiredAccess: AccountsAccessRights.Disbursement,
    },
    {
        text: "Pay Disbursement",
        name: "Pay Disbursement",
        icon: "k-i-minus",
        id: MenuItemId.DisbursementPayments,
        parentId: MenuItemId.Purchase,
        route: "/paydisbursement",
        requiredAccess: AccountsAccessRights.PayDisbursement,
    },
    {
        text: "Pay Supplier",
        name: "Pay Supplier",
        icon: "k-i-minus",
        id: MenuItemId.SupplierPayments,
        parentId: MenuItemId.Purchase,
        route: "/paysupplier",
        requiredAccess: AccountsAccessRights.PaySupplier,
    },
    // {
    //     text: "Creditors Management",
    //     name: "Creditors Management",
    //     icon: "k-i-minus",
    //     id: MenuItemId.CreditorsManagement,
    //     parentId: MenuItemId.Purchase,
    //     route: "/creditorsmanagement",
    //     requiredAccess: AccountsAccessRights.PaySupplier,
    // },
    {
        text: "Payment Run",
        name: "Payment Run",
        icon: "k-i-minus",
        id: MenuItemId.PaymentRun,
        parentId: MenuItemId.Purchase,
        route: "/paymentrun",
        flag: "last",
        requiredAccess: AccountsAccessRights.PaySupplier,
    },
    {
        id: MenuItemId.Admin,
        text: "Admin",
        icon: Admin,
        ["data-expanded"]: false,
        parent: true.toString(),
        route: "/admin",
        tabId: Tabs.ADMIN,
        requiredAccess: AccountsAccessRights.AccountsAdmin,
    },
    {
        id: MenuItemId.ChitPosting,
        parentId: MenuItemId.Admin,
        text: "Chit Posting",
        name: "Chit Posting",
        icon: "k-i-minus",
        route: "/chitposting",
        flag: "first",
        requiredAccess: AccountsAccessRights.AccountsAdmin,
    },
    {
        id: MenuItemId.BillRequests,
        parentId: MenuItemId.Admin,
        text: "Bill Requests",
        name: "Bill Requests",
        icon: "k-i-minus",
        route: "/billrequests",
        requiredAccess: AccountsAccessRights.AccountsAdmin,
    },
    {
        id: MenuItemId.TransactionSearch,
        parentId: MenuItemId.Admin,
        text: "Transaction Search",
        name: "Transaction Search",
        icon: "k-i-minus",
        route: "/transactionsearch",
        requiredAccess: AccountsAccessRights.AccountsAdmin,
    },
    {
        id: MenuItemId.PaymentProcessing,
        parentId: MenuItemId.Admin,
        text: "Payment Processing",
        name: "Payment Processing",
        icon: "k-i-minus",
        route: "/paymentprocessing",
        flag: "last",
        requiredAccess: AccountsAccessRights.AccountsAdmin,
    },
    {
        id: MenuItemId.FeeEarner,
        text: "Fee Earner",
        ["data-expanded"]: false,
        icon: Feeearner,
        parent: true.toString(),
        route: "/feeearner",
        tabId: Tabs.FEE_EARNER,
    },
    {
        id: MenuItemId.TimeRecorded,
        parentId: MenuItemId.FeeEarner,
        text: "Time Recorded",
        name: "Time Recorded",
        route: "/timerecorded",
        flag: "first",
    },
    {
        id: MenuItemId.MyMatters,
        parentId: MenuItemId.FeeEarner,
        text: "My Matters",
        name: "My Matters",
        route: "/myMatters",
    },
    {
        id: MenuItemId.TimeRecording,
        parentId: MenuItemId.FeeEarner,
        text: "Time Recording",
        name: "Time Recording",
        route: "/timerecording",
    },
    {
        id: MenuItemId.ChitRequest,
        parentId: MenuItemId.FeeEarner,
        text: "Chit Request",
        name: "Chit Request",
        icon: "k-i-minus",
        route: "/chitrequest",
    },
    {
        id: MenuItemId.BillingRequest,
        parentId: MenuItemId.FeeEarner,
        text: "Billing Request",
        name: "Billing Request",
        icon: "k-i-minus",
        route: "/billingrequest",
    },
    {
        id: MenuItemId.Authorisations,
        parentId: MenuItemId.FeeEarner,
        text: "Authorisations",
        name: "Authorisations",
        icon: "k-i-minus",
        route: "/authorisations",
        flag: "last",
    },

    {
        id: MenuItemId.Reports,
        text: "Reports",
        name: "Reports",        
        icon: Reports,
        route: "/reports",
        tabId: Tabs.REPORTS,
    },
    {
        id: MenuItemId.ClientListingReport,
        parentId: MenuItemId.Reports,
        text: "Client Listing",
        name: "Client Listing",
        icon: "k-i-minus",
        route: "/clientlisting",        
        requiredAccess: ReportsAccessRights.ClientListing,
    },
    {
        id: MenuItemId.MatterBalanceReport,
        parentId: MenuItemId.Reports,
        text: "Matter Balances",
        name: "Matter Balances",
        icon: "k-i-minus",
        route: "/matterbalances",        
        requiredAccess: ReportsAccessRights.MatterBalances,
    },
    {
        id: MenuItemId.DisbursementReport,
        parentId: MenuItemId.Reports,
        text: "Disbursements",
        name: "Disbursements",
        icon: "k-i-minus",
        route: "/disbursements",        
        requiredAccess: ReportsAccessRights.Disbursements,
    },
    {
        id: MenuItemId.BillingReport,
        parentId: MenuItemId.Reports,
        text: "Billing",
        name: "Billing",
        icon: "k-i-minus",
        route: "/billing",        
        requiredAccess: ReportsAccessRights.Billing,
    },
    {
        id: MenuItemId.SupplierBalanceReport,
        parentId: MenuItemId.Reports,
        text: "Suppliers",
        name: "Suppliers",
        icon: "k-i-minus",
        route: "/supplierbalances",        
        requiredAccess: ReportsAccessRights.SupplierBalance,
    },
    {
        id: MenuItemId.TrialBalanceReport,
        parentId: MenuItemId.Reports,
        text: "Nominals",
        name: "Nominals",
        icon: "k-i-minus",
        route: "/nominalbalances",        
        requiredAccess: ReportsAccessRights.NominalBalance,
    },

    {
        id: MenuItemId.BankRecReport,
        parentId: MenuItemId.Reports,
        text: "Bank Rec",
        name: "Bank Rec",
        icon: "k-i-minus",
        route: "/bankrec",        
        requiredAccess: ReportsAccessRights.BankRec,
    },
];
